<template>
  <div>
    <byted-modal class="double-check" :value="modelShow" :size="size" :mask-closable="false" @input="$emit('input')">
      <template slot="body">
        <div class="double-check-body">
          <div class="double-check-title">{{ title }}</div>
          <!--投放目标-->
          <div class="double-check-row" v-if="optimizeTarget">
            <div class="double-check-row-label">{{ $bp_t('投放目标', 'common.launch_target') }}</div>
            <div class="double-check-row-content">{{ optimizeTargetText }}</div>
          </div>

          <!--转化目标-->
          <div class="double-check-row" v-if="isOptimizeTargetTransform && convertGoalText">
            <div class="double-check-row-label">{{ $bp_t('转化目标', 'common.external_action') }}</div>
            <div class="double-check-row-content">{{ convertGoalText }}</div>
          </div>

          <!--目标出价-->
          <div :class="['double-check-row', bidWarning && 'has-warning']" v-if="bid">
            <div class="double-check-row-label">{{ bidLabel }}</div>
            <div class="double-check-row-content">
              <span class="double-check-row-content-price">{{ bid }}</span>
              <span>{{ $bp_t('元', 'common.element') }}</span>
              <span v-if="bidWarning" class="double-check-row-content-warning">
                <byted-icon name="exclamation-circle" color="#FFA900" />
                {{ bidWarning }}
              </span>
            </div>
          </div>

          <!--深度转化出价-->
          <div :class="['double-check-row', deepBidWarning && 'has-warning']" v-if="isShowDeepBid">
            <div class="double-check-row-label">{{ $bp_t('深度转化出价', 'common.deep_cpabid') }}</div>
            <div class="double-check-row-content">
              <span class="double-check-row-content-price">{{ deepBid }}</span><span>{{ $bp_t('元', 'common.element') }}</span>
              <span v-if="deepBidWarning" class="double-check-row-content-warning">
                <byted-icon name="exclamation-circle" color="#FFA900" />{{ deepBidWarning }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <byted-button type="default" @click="onCancelClick">{{ btnTextCancel }}</byted-button>
        <byted-button type="primary" @click="onConfirmClick">{{ btnTextConfirm }}</byted-button>
      </template>
    </byted-modal>
  </div>
</template>

<script>
import { optimizeTargets } from 'Src/const/state/common'
import { catchableParse } from 'Src/util/json'
import { loginType } from 'Src/const/state/ad'
import tool from 'Src/util/tool'

const QUERY = tool.queryToJson()

const TAE_EVENT_BASIC_PARAMS = {
  from: '',
  advertiser_id: GLOBAL_VAR.advertiser.id,
  customer_type: GLOBAL_VAR.customerType,
  login_type: (() => {
    switch (true) {
      // 账户密码登录
      case catchableParse(GLOBAL_VAR.isAdmin):
        return loginType.isAdmin
      // 内部系统附身: 内部优化师
      case catchableParse(GLOBAL_VAR.sales):
        return loginType.isStaff
      // 外部系统附身: 代理商 + 账户管家附身
      case catchableParse(GLOBAL_VAR.user_jobbed):
        return loginType.isCoreUser
      default:
        return 0
    }
  })()
}

export default {
  name: 'double-check-modal',
  props: {
    modelShow: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    title: {
      type: String,
      default: $bp_t('当前输入出价过高，请检查是否正确', 'bp.over_price_tip')
    },
    btnTextCancel: {
      type: String,
      default: $bp_t('返回修改', 'bp.creative_create_return_modify')
    },
    btnTextConfirm: {
      type: String,
      default: '确认并保存'
    },
    // 投放目标
    optimizeTarget: {
      type: Number,
      default: 0
    },
    // 转化目标
    convertGoalText: {
      type: String,
      default: ''
    },
    // 目标出价
    bid: {
      type: [Number, String],
      default: ''
    },
    // 原目标出价
    bidOrig: {
      type: [Number, String],
      default: ''
    },
    bidWarning: {
      type: String,
      default: ''
    },
    bidLabel: {
      type: String,
      default: '目标转化出价'
    },
    // 深度转化出价
    deepBid: {
      type: [Number, String],
      default: ''
    },
    // 原深度转化出价
    deepBidOrig: {
      type: [Number, String],
      default: ''
    },
    deepBidWarning: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    externalAction: {
      type: [String, Number],
      default: ''
    },
    convertId: {
      type: [String, Number],
      default: ''
    },
    teaEventNameShow: {
      type: String,
      default: 'bid_popover_popup'
    },
    teaEventNameConfirm: {
      type: String,
      default: 'bid_popover_save'
    },
    teaEventNameCancel: {
      type: String,
      default: 'bid_popover_back'
    },
    teaFrom: {
      type: String,
      default: ''
    },
  },
  model: {
    prop: 'modelShow',
    event: 'input'
  },
  watch: {
    modelShow(newVal) {
      if (newVal)
        window.teaEvent(this.teaEventNameShow, {
          ...TAE_EVENT_BASIC_PARAMS,
          ...this.customTeaEventParams
        })
    }
  },
  computed: {
    isShowDeepBid () {
      if (!this.optimizeTarget) return this.deepBid
      return this.isOptimizeTargetTransform && this.deepBid
    },
    isOptimizeTargetTransform () {
      return this.optimizeTarget === optimizeTargets.TRANSFORM.value
    },
    optimizeTargetText() {
      const targetOption = Object.values(optimizeTargets).find(({ value }) => value === this.optimizeTarget)
      return targetOption ? targetOption.text : ''
    },
    customTeaEventParams() {
      return {
        old_bid: Number(this.bidOrig) || '',
        new_bid: Number(this.bid) || '',
        old_deep_cpa_bid: Number(this.deepBidOrig) || '',
        new_deep_cpa_bid: Number(this.deepBid) || '',
        convert_id: this.convertId || '',
        external_action: String(this.externalAction) || '',
        from: this.teaFromQuery || ''
      }
    },
    teaFromQuery () {
      let fromQuery = this.teaFrom
      const match = window.location.pathname.match(/pages\/ad\/(create|batch_copy_ad}).html/)
      if (match && match[1]) {
        if (match[1] === 'batch_copy_ad') {
          // 批量复制计划
          fromQuery = 'batch_copy'
        } else if (QUERY.origin_ad_id) {
          // 复制计划
          fromQuery = 'copy'
        } else if (QUERY.ad_id) {
          // 编辑计划
          fromQuery = 'modified'
        } else {
          // 新建计划
          fromQuery = 'create'
        }
      }
      return fromQuery
    }
  },
  methods: {
    closeModal() {
      this.$emit('input', false)
    },
    onCancelClick() {
      this.closeModal()
      this.$emit('cancel')
      window.teaEvent(this.teaEventNameCancel, {
        ...TAE_EVENT_BASIC_PARAMS,
        ...this.customTeaEventParams
      })
    },
    onConfirmClick() {
      this.closeModal()
      if (this.onConfirm) this.onConfirm()
      this.$emit('confirm')
      window.teaEvent(this.teaEventNameConfirm, {
        ...TAE_EVENT_BASIC_PARAMS,
        ...this.customTeaEventParams
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.double-check {
  &-title {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #333;
    margin-bottom: 24px;
  }

  &-row {
    font-size: 14px;
    line-height: 22px;
    color: #333;
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    &-label {
      color: #999;
      width: 98px;
    }

    &-content {
      flex: 1;

      &-warning {
        .byted-icon {
          vertical-align: -2px;
          margin-left: 12px;
        }
      }
    }

    &.has-warning {
      border-radius: 4px;
      background-color: #f8f9fa;
      padding: 12px;
      margin-left: -12px;
      margin-right: -12px;

      .double-check-row-content-price {
        font-size: 28px;
        line-height: 41px;
        color: #414141;
      }
    }
  }
}
</style>
